import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import TextInput from 'web/components/form-elements/TextInput';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import DatePicker from 'web/components/form-elements/DatePicker';
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import NumberInput from "web/components/form-elements/NumberInput";
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { buyerInvCheckoutAcceptApi, checkPromoIsValidApi } from 'redux/actions/checkout';

import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";

import PaymentModule from '../PaymentModule';
import DummyPallets from 'web/assets/images/pallet-home-image.jpg';
import { DateTimeWrapper1, OrderDetail, PayWith, Address, ReviewOrder, Heading, AccountSection, AccountType, Location, To, ReviewFooter, Des, CommentSection, } from '../checkOutStyle';
import { fetchLanguageContentNew } from 'redux/actions/language';
import AddressEditForm from '../AddressEditForm';
import AltOptionsForm from './AltOptionsForm'

const BuyerInventory = ({ callBackCheckoutFetchApi, checkoutPageData, props }) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const urlObject = useSelector((state) => state.urlParameters.checkout);
    const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
    const isBroker = localStorage.getItem('brokerAccount')
    const token = localStorage.getItem('token');
    const [tooltip, setTooltip] = useState(false);

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [promoCodeDetails, setPromoCodeDetails] = useState()
    const [promoCodeErrorMessage, setPromoCodeErrorMessage] = useState('')
    const [offerAmountValue, setOfferAmountValue] = useState('')

    const [alertType, setAlertType] = useState('')
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    useEffect(() => {
        let offerAmountTemp = ''
        if (props?.values?.offerAmount !== '') {
            offerAmountTemp = props.values?.offerAmount.substring(1).split(",").join("");
            offerAmountTemp = parseFloat(offerAmountTemp)
        } else if (urlObject?.type === 'buyerInvCheckoutbuynow') {
            offerAmountTemp = checkoutPageData?.buyNowDeliveredPrice
        } else if (urlObject?.type === 'buyerInvCheckoutbuynowcpu') {
            offerAmountTemp = checkoutPageData?.buyNowPickupPrice
        }
        setOfferAmountValue(offerAmountTemp)
    }, [props])

    useEffect(() => {
        // setting the operatinal days and timings
        const { setFieldValue } = props
        if (checkoutPageData?.offerAlreadyMade) {
            if ((checkoutPageData?.offerType === 'OFFER' && urlObject?.type === 'buyerInvCheckoutmakeOffer') ||
                (checkoutPageData?.offerType === 'ALTOFFER' && urlObject?.type === 'buyerInvCheckoutmakeAltOffer') ||
                (checkoutPageData?.offerType === 'BUYNOW' && urlObject?.type === 'buyerInvCheckoutbuynow') ||
                (checkoutPageData?.offerType === 'BUYNOWCPU' && urlObject?.type === 'buyerInvCheckoutbuynowcpu')) {
                setAlertType('redirectCheckoutToMyOffers')
                setModalContent('Offer has been already made on this inventory.');
                setModalLink();
                toggleModal();
            }
        }

        // below logic is handled in utils file, commented here for futur ref if needed
        // if (checkoutPageData) {
        //     if (props.values?.curentShippingMode === 'DELIVERY') {
        //         setFieldValue('checkOutStartTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourStart)
        //         setFieldValue('checkOutEndTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourEnd)
        //         setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourStart)
        //         setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourEnd)
        //     } else {
        //         setFieldValue('checkOutStartTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourStart)
        //         setFieldValue('checkOutEndTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourEnd)
        //         setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourStart)
        //         setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourEnd)
        //     }
        // }
    }, [checkoutPageData])

    useEffect(() => {
        if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    const poNumber = (type) => {
        return <div>
            <Heading>{pageLanguageContents?.BuyModal[13]?.PONumber}</Heading>
            <TextInput
                name='poNumber'
                placeholder={pageLanguageContents?.BuyModal[13]?.PONumber}
                maxLength='20'
                showErrorMessages={true}
                disabled={type === 'disabled' ? true : false}
            />
        </div>
    }

    const toolTipFunction = (infoTxt) => {
        return (
            <>
                <img
                    id='invalidPromoToolTip'
                    src={information}
                    style={{ position: "relative", top: "-1px", marginLeft: "6px", }}
                />
                <Tooltip
                    placement="right"
                    isOpen={tooltip}
                    target='invalidPromoToolTip'
                    toggle={() => setTooltip(!tooltip)}
                >
                    {infoTxt}
                </Tooltip >
            </>
        );
    };

    const promoButtonStyle = {
        background: 'linear-gradient(90deg, #55C416 1.12%, #367910 100%)',
        border: 'none',
        borderRadius: '4px',
        color: '#fff',
        margin: '0px'
    }
    const promoButtonStyleDisabled = {
        background: 'linear-gradient(90deg, #55C416 1.12%, #367910 100%)',
        border: 'none',
        borderRadius: '4px',
        color: '#fff',
        opacity: '0.5',
        margin: '0px'
    }

    const promoCodeSection = (propValues) => {
        return (
            <div style={{ margin: '16px 0px 0px 0' }}>
                <div style={{ display: 'grid', height: '38px', gridTemplateColumns: '4fr 1fr' }}>
                    <div className={promoCodeErrorMessage !== '' && 'invalidPromoCodeStyle'} style={{ position: 'relative', marginRight: '15px' }}>
                        <span style={{ pointerEvents: "auto", position: 'absolute', left: '-30px', top: '6px' }}>{toolTipFunction('Final promo amount will be calculated at order completion and processed as a rebate.')}</span>
                        <TextInput
                            name='checkoutPromoCode'
                            maxLength='50'
                            inputType='checkoutPagePromoCode'
                            placeholder='Enter promo code'
                            changeHandler={(value) => {
                                setPromoCodeErrorMessage('')
                                setPromoCodeDetails()
                                const { setFieldValue } = props
                                setFieldValue('promoCodeVaidated', false)
                            }}
                        />
                        {props?.values?.promoCodeVaidated && <div style={{ position: 'absolute', fontSize: '13px', top: '35px', color: 'green', whiteSpace: 'nowrap' }}>{`(Rebate of $ ${promoCodeDetails?.calDiscountAmt?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`}</div>}
                        {promoCodeErrorMessage !== '' && <div style={{ position: 'absolute', fontSize: '13px', top: '35px', color: '#ff0000', whiteSpace: 'nowrap' }}>Invalid promocode.</div>}
                    </div>
                    <button style={propValues?.checkoutPromoCode === '' ? promoButtonStyleDisabled : promoButtonStyle} disabled={propValues?.checkoutPromoCode === ''} onClick={() => checkPromoCodeIsValid(propValues)}>Apply</button>
                </div>
            </div>
        )
    }

    const checkPromoCodeIsValid = async (values) => {
        if (offerAmountValue === '') {
            setModalContent('Please enter the offer amount.');
            setModalLink();
            toggleModal();
            return
        }
        let apiResponse
        let data = {
            locationId: localStorage.getItem('locationID'),
            promoCode: values.checkoutPromoCode,
            productPrice: checkoutPageData?.qty * offerAmountValue
        }
        apiResponse = await dispatch(checkPromoIsValidApi(data, token));
        if (apiResponse.calDiscountAmt) {
            const { setFieldValue } = props
            setFieldValue('promoCodeVaidated', true)
            setPromoCodeDetails(apiResponse)
            setPromoCodeErrorMessage('')
        } else {
            setPromoCodeDetails()
            setPromoCodeErrorMessage(apiResponse.data?.message || apiResponse.message || 'Something went wrong, please try again after sometime.')
        }
    }

    const btnsAttach = () => {
        let error = JSON.parse(JSON.stringify(props.errors))
        let buttonEnable = true
        delete error.deliveryline1
        delete error.deliveryname
        if (Object.keys(error).length !== 0) buttonEnable = false
        if (offerAmountValue === '') buttonEnable = false
        if (props.values?.invCheckoutIsAltQty === 'altqtyyes' && props.values?.offerQty === '') buttonEnable = false
        if (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') {
            if (props.values?.brokername === '' || props.values?.brokerline1 === '' || props.values?.brokercity === '' ||
                props.values?.brokerstate === '' || props.values?.brokerzip === '' || props.values?.offerQty === '') {
                buttonEnable = false
            }
        }

        return (
            <>
                <>
                    <div className="checkout-note">
                        <Heading>Note to Seller</Heading>
                        <div className="app-input-text">
                            <textarea
                                name="note"
                                maxLength="500"
                                onChange={(event) => {
                                    const { setFieldValue } = props
                                    setFieldValue('note', event.target.value)
                                }}
                            />
                        </div>
                    </div>
                </>
                {props.values?.achSelected &&
                    <div>
                        <CheckboxInput
                            name="achAcknowledgeCheck"
                            label="I authorize that you can withdraw funds from my ACH account. If it fails, you can use my credit card."
                            handleSelect={() => { }}
                        />
                    </div>
                }
                <ReviewFooter>
                    <Button
                        type=''
                        handleClick={() => acceptFunction()}
                        disabled={(props.values?.achSelected && !props.values.achAcknowledgeCheck) || !buttonEnable}>
                        Submit
                    </Button>
                </ReviewFooter>
            </>
        );
    };

    const acceptFunction = async () => {
        let pageValues = props.values
        if (pageValues?.paymentMethod === '') {
            setModalContent('Please provide payment details.');
            setModalLink();
            toggleModal();
            return
        }
        if (pageValues.checkoutPromoCode !== '' && !pageValues?.promoCodeVaidated) {
            setModalContent('Please validate the promocode.');
            setModalLink();
            toggleModal();
            return
        }
        if (pageValues?.achSelected && pageValues.achBackUpCard === '') {
            setModalContent('Please select a backup card for ACH mode of payment.');
            setModalLink();
            toggleModal();
            return
        }
        let deliveryWindowBegin = props.values?.checkOutStartTimeBuyerOffer;
        let deliveryWindowEnd = props.values?.checkOutEndTimeBuyerOffer;
        if (props.values?.invCheckoutIsAltDate === 'altdateyes' || props.values?.invCheckoutIsAltMode === 'altmodeyes') {
            deliveryWindowBegin = props.values?.checkOutAltStartTimeBuyerOffer;
            deliveryWindowEnd = props.values?.checkOutAltEndTimeBuyerOffer
        }
        const fromTimeValue = parseInt(deliveryWindowBegin?.replace(":", ""));
        const toTimeValue = parseInt(deliveryWindowEnd?.replace(":", ""));
        if (!(toTimeValue > fromTimeValue)) {
            setModalContent(props.values?.curentShippingMode === 'DELIVERY' ? "Delivery window time is invalid." : "Pickup window time is invalid.");
            setModalLink("");
            toggleModal();
            return
        }

        let offerTypeValue, response;
        if (urlObject?.type === 'buyerInvCheckoutmakeOffer') offerTypeValue = 'OFFER'
        else if (urlObject?.type === 'buyerInvCheckoutmakeAltOffer') offerTypeValue = 'ALTOFFER'
        else if (urlObject?.type === 'buyerInvCheckoutbuynow') offerTypeValue = 'BUYNOW'
        else if (urlObject?.type === 'buyerInvCheckoutbuynowcpu') offerTypeValue = 'BUYNOWCPU'

        let requestDateValue = moment(props.values.checkOutDateBuyerOffer).format('YYYY-MM-DD')
        if (props.values?.invCheckoutIsAltDate === 'altdateyes') requestDateValue = moment(props.values.checkOutAltDateBuyerOffer).format('YYYY-MM-DD')

        let qtyValue = checkoutPageData.qty
        if (offerTypeValue === 'ALTOFFER') {
            if (props.values?.invCheckoutIsAltQty === 'altqtyyes') qtyValue = props.values?.offerQty
        }

        if (parseInt(qtyValue) < 1) {
            setModalContent('Quantity should be greater than 0.');
            setModalLink("");
            toggleModal();
            return
        }

        let data = {
            authId: localStorage.getItem('authId'),
            inventoryId: urlObject?.id,
            offerType: offerTypeValue,
            offerPrice: offerAmountValue,
            requestedDate: requestDateValue,
            shippingMode: props?.values?.curentShippingMode,
            appointmentStartTime: deliveryWindowBegin?.substring(0, 5),
            appointmentEndTime: deliveryWindowEnd?.substring(0, 5),
            qty: qtyValue,
            shippingAddress: {
                locationName: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokername :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupname : props?.values?.deliveryname,
                address1: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokerline1 :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupline1 : props?.values?.deliveryline1,
                address2: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokerline2 :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupline2 : props?.values?.deliveryline2,
                city: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokercity :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupcity : props?.values?.deliverycity,
                state: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokerstate :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupstate : props?.values?.deliverystate,
                zipCode: (isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY') ? props?.values?.brokerzip :
                    (props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ? props?.values?.pickupzip : props?.values?.deliveryzip,
            },
            promoCode: pageValues?.promoCodeVaidated ? pageValues.checkoutPromoCode : '',
            poNumber: pageValues?.poNumber,
            paymentMethod: pageValues?.paymentMethod,
            paymentMethodId: pageValues?.cardTypeRadio,
            comment: pageValues?.note,
            achPaymentMethodIds: null,
        }
        if (pageValues?.achSelected) {
            data.achPaymentMethodIds = [pageValues?.cardTypeRadio, pageValues?.achBackUpCard]
        }
        response = await dispatch(buyerInvCheckoutAcceptApi(data, token));
        if (response?.success) {
            setAlertType('buyerInvCheckoutAccept')
            setModalContent(response?.data?.msg);
            setModalLink();
            toggleModal();
        } else if (response.statusCode === 401) {
            history.push('/sign-in');
            window.location.reload(false);
        } else {
            if (response?.data?.error?.message?.includes('Please withdraw')) {
                setAlertType('redirectCheckoutToMyOffers')
            }
            setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
            setModalLink("");
            toggleModal();
        }
    }

    const inventoryDetailsSummary = () => {
        let palletDetails = urlObject?.palletDetails
        if (palletDetails) {
            const capitalize = (s) => {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
            const gradeSize = () => {
                let commodityDim = "";
                if (palletDetails?.length) {
                    commodityDim = palletDetails?.length + "x" + palletDetails?.width + "x" + palletDetails?.height;
                } else {
                    if (palletDetails?.size) {
                        commodityDim = capitalize(palletDetails?.size.toLowerCase());
                    } else {
                        if (palletDetails?.grade && palletDetails?.gradeName) {
                            commodityDim = capitalize(palletDetails?.gradeName.toLowerCase());
                        }
                    }
                }
                return commodityDim;
            };

            const getGradeName = () => {
                let gradeName = "";
                if (palletDetails?.grade) gradeName = palletDetails?.grade
                return gradeName;
            };

            const getCommodity = () => {
                let commodityVal = "";
                if (palletDetails?.palletType) commodityVal = capitalize(palletDetails?.palletType.toLowerCase())
                else if (palletDetails?.material === 'PLASTIC') commodityVal = 'Plastic'
                else if (palletDetails?.material === 'OTHER') commodityVal = 'Custom'
                return commodityVal;
            };

            const getMoisture = () => {
                let moistureVal = "";
                if (palletDetails?.moisture) moistureVal = palletDetails?.moisture
                return capitalize(moistureVal.toLowerCase());
            };

            let requestDate = moment(props.values?.checkOutDateBuyerOffer).format('MM/DD/YYYY')
            if (props?.values?.invCheckoutIsAltDate === 'altdateyes') requestDate = moment(props.values?.checkOutAltDateBuyerOffer).format('MM/DD/YYYY')

            const tConvert = (time) => {
                if (time) {
                    time = time
                        .toString()
                        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

                    if (time.length > 1) {
                        time = time.slice(1);

                        time[5] = +time[0] < 12 ? " AM" : " PM";
                        time[0] = +time[0] % 12 || 12;
                    }
                    return time.join("");
                }
            }

            const getTimings = () => {
                return `${tConvert(props?.values?.checkOutAltStartTimeBuyerOffer?.substring(0, 5))} - ${tConvert(props?.values?.checkOutAltEndTimeBuyerOffer?.substring(0, 5))}`;
            }

            const getDeliveryMode = () => {
                let mode = "";
                if (props?.values?.curentShippingMode === 'DELIVERY') mode = "Delivery"
                else mode = "Pickup"
                return mode;
            }

            return `${checkoutPageData?.qty} ${gradeSize()} ${getCommodity()} ${getMoisture()} ${getGradeName()} pallets for ${getDeliveryMode()}`
        }
    }

    return (
        <>
            <div></div>
            <div className="checkout-cont">
                <Description>
                    <div className="product-header-sec">
                        <img
                            src={RightArrow}
                            alt="RightArrow"
                            className="right-arrow"
                        />
                        <div class="community-name">
                            <h6>{urlObject?.type === 'buyerInvCheckoutmakeOffer' ? 'Make Offer' :
                                urlObject?.type === 'buyerInvCheckoutmakeAltOffer' ? 'Make an Alternative Offer' :
                                    'Make Buy Now Offer'}</h6>
                        </div>
                    </div>
                </Description>

                <p style={{ margin: '18px 0 0 0', paddingLeft: "62px" }}>
                    {urlObject?.type === 'buyerInvCheckoutmakeOffer' ? 'Complete the offer form below by inputting an offer amount, the delivery date and time, and payment method. If your offer is accepted, you will receive an order confirmation.' :
                        urlObject?.type === 'buyerInvCheckoutmakeAltOffer' ? `Use the alternative offer selection to alter the quantity of your offer, alter the mode (pickup vs delivery), or alter the date if you need the pallets to be available outside of the seller's usual business days. If your offer is accepted, you will receive an order confirmation.` :
                            urlObject?.type === 'buyerInvCheckoutbuynow' ? `Complete the buy now offer form below by inputting an offer amount, the requested delivery date and time, and payment method. If your offer is accepted, you will receive an order confirmation.` :
                                urlObject?.type === 'buyerInvCheckoutbuynowcpu' ? `Complete the buy now offer form below by inputting an offer amount, the requested pickup date and time, and payment method. If your offer is accepted, you will receive an order confirmation.` :
                                    ''
                    }
                </p>

                {urlObject?.type === 'buyerInvCheckoutmakeAltOffer' &&
                    <p style={{ fontFamily: "latobold", fontSize: '17px', marginTop: '20px' }}>
                        Post Summary Details: {inventoryDetailsSummary()}
                    </p>
                }

                {(urlObject?.type === 'buyerInvCheckoutmakeOffer' || urlObject?.type === 'buyerInvCheckoutmakeAltOffer') &&
                    <div className='offer-amt-styles mb-4'>
                        <h6>Offer Amount:</h6>
                        <NumberInput
                            name="offerAmount"
                            prefix={"$"}
                            placeholder="$ 0.00"
                            decimalScale={2}
                            maxLength={8}
                            decimalSeparator=","
                            fixedDecimalScale
                            thousandSeparator={true}
                        />
                    </div>
                }

                {urlObject?.type === 'buyerInvCheckoutmakeAltOffer' &&
                    <AltOptionsForm
                        checkoutPageData={checkoutPageData}
                        props={props}
                        pageLanguageContents={pageLanguageContents}
                    />
                }

                <PayWith>
                    <Location>
                        {(props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ?
                            <Heading>{pageLanguageContents?.BuyModal[7]?.PickupLocation}</Heading>
                            :
                            <Heading>{pageLanguageContents?.BuyModal[6]?.DeliveryAddress}</Heading>
                        }

                        {(isBroker === 'brokerAc' && props.values?.curentShippingMode === 'DELIVERY' && urlObject?.type !== 'buyerInvCheckoutbuynowcpu') ?
                            <AddressEditForm props={props} checkoutPageData={checkoutPageData} />
                            :
                            props.values?.curentShippingMode === 'DELIVERY' ?
                                <Address>
                                    <p style={{ fontWeight: 'bold' }}>{props?.values?.deliveryname}</p>
                                    <p>{props?.values?.deliveryline1}</p>
                                    {props?.values?.deliveryline2 && <p>{props?.values?.deliveryline2}</p>}
                                    <p>{props?.values?.deliverycity},&nbsp;{stateConvert(props?.values?.deliverystate)}&nbsp;{props?.values?.deliveryzip}</p>
                                </Address>
                                :
                                <Address>
                                    {/* <p style={{ fontWeight: 'bold' }}>{props?.values?.pickupname}</p>
                                    <p>{props?.values?.pickupline1}</p>
                                    {props?.values?.pickupline2 && <p>{props?.values?.pickupline2}</p>} */}
                                    <p>{props?.values?.pickupcity},&nbsp;{stateConvert(props?.values?.pickupstate)}&nbsp;{props?.values?.pickupzip}</p>
                                    <p className='discalimerStyle'>Full address details will be displayed once the order is authenticated.</p>
                                </Address>
                        }


                        {urlObject?.type !== 'buyerInvCheckoutmakeAltOffer' &&
                            <DateTimeWrapper1>
                                <DeliveryWindowSection>
                                    <div>
                                        {(props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ?
                                            <Heading>{pageLanguageContents?.BuyModal[8]?.PickupDate}</Heading>
                                            :
                                            <Heading>{pageLanguageContents?.BuyModal[11]?.DeliveryDate}</Heading>
                                        }
                                        <DatePicker
                                            name="checkOutDateBuyerOffer"
                                            type="DatesDisabled"
                                            checkoutPageType={urlObject?.type}
                                            minDate={props.values?.checkOutDateBuyerOfferMinDate}
                                            selectedDate={props.values?.checkOutDateBuyerOffer}
                                            nonDisabledDaysList={props.values?.curentShippingMode === 'DELIVERY' ?
                                                checkoutPageData?.deliveryOperationDetails?.locationDaysOfOperations :
                                                checkoutPageData?.pickupOperationDetails?.locationDaysOfOperations
                                            }
                                        // disabled={urlObject?.type === 'buyerInvCheckoutmakeOffer' ? true : false}
                                        />
                                    </div>
                                    <div>
                                        {(props.values?.curentShippingMode === 'PICKUP' || urlObject?.type === 'buyerInvCheckoutbuynowcpu') ?
                                            <Heading>{pageLanguageContents?.BuyModal[9]?.PickupTime}</Heading>
                                            :
                                            <Heading>{pageLanguageContents?.BuyModal[12]?.DeliveryTime}</Heading>
                                        }
                                        <div className="d-flex align-items-center">
                                            <TimePickerInput
                                                name="checkOutStartTimeBuyerOffer"
                                                type="time"
                                                selectedValue={props.values?.checkOutStartTimeBuyerOffer}
                                                showErrorMessages={true}
                                                props={props}
                                            // disabled={urlObject?.type === 'buyerInvCheckoutmakeOffer' ? true : false}
                                            />
                                            <To>
                                                {pageLanguageContents?.BuyModal[10]?.To}
                                            </To>
                                            <TimePickerInput
                                                name="checkOutEndTimeBuyerOffer"
                                                type="time"
                                                selectedValue={props.values?.checkOutEndTimeBuyerOffer}
                                                showErrorMessages={true}
                                                props={props}
                                            // disabled={urlObject?.type === 'buyerInvCheckoutmakeOffer' ? true : false}
                                            />
                                        </div>
                                    </div>
                                    {poNumber()}
                                </DeliveryWindowSection>
                            </DateTimeWrapper1>
                        }

                        {/* {urlObject?.type === 'buyerInvCheckoutmakeAltOffer' &&
                            <DateTimeWrapper1>
                                <DeliveryWindowSection>
                                    {poNumber()}
                                </DeliveryWindowSection>
                            </DateTimeWrapper1>
                        } */}

                        <>
                            <Heading>
                                {pageLanguageContents?.BuyModal[24]?.PayWith}
                            </Heading>

                            <AccountSection>
                                <AccountType>
                                    <PaymentModule
                                        props={props}
                                        checkoutPageData={checkoutPageData}
                                        callBackCheckoutFetchApi={callBackCheckoutFetchApi}
                                    />
                                </AccountType>
                            </AccountSection>
                        </>

                        {checkoutPageData?.bidderComment && (
                            <CommentSection>
                                <>
                                    <div>
                                        <h3>{checkoutPageData?.bidderName}<span>:</span></h3>
                                        <p>{checkoutPageData?.bidderComment ? checkoutPageData?.bidderComment : ""}</p>
                                    </div>
                                </>
                            </CommentSection>
                        )}
                    </Location>
                </PayWith>
                <ReviewOrder>
                    <Heading>{pageLanguageContents?.BuyModal[29]?.ReviewOrder}</Heading>

                    <OrderDetail>
                        <div className="checkout-total">
                            <div className="checkout-product-detail">
                                <div className="checkout-product-img">
                                    <div className="checkout-img p-2 text-center">
                                        <img src={checkoutPageData?.postImageFiles ? `${fileUrl}${checkoutPageData?.postImageFiles[0].fileName}` : DummyPallets} />
                                    </div>
                                </div>
                                <div className="checkout-product-desc">
                                    <h2>{checkoutPageData?.postName}</h2>
                                    <Des>{checkoutPageData?.postComment}</Des>
                                </div>
                            </div>
                            <div className="checkout-count-table">
                                <p>
                                    <b>{pageLanguageContents?.BuyModal[30]?.Quantity}<span>:</span></b>
                                    <span>{props.values?.invCheckoutIsAltQty === 'altqtyyes' ? props.values?.offerQty : checkoutPageData?.qty}&nbsp;</span>
                                </p>
                                <p>
                                    <b>{pageLanguageContents?.BuyModal[33]?.Price_Pallet}<span>:</span></b>
                                    <span>
                                        <CurrencyFormat
                                            prefix={"$"}
                                            value={offerAmountValue !== '' ? offerAmountValue?.toFixed(2) : ''}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </p>
                                <p>
                                    <b>{pageLanguageContents?.BuyModal[34]?.Subtotal}<span>:</span>
                                    </b>
                                    <span>
                                        <CurrencyFormat
                                            prefix={"$"}
                                            value={offerAmountValue !== '' ? (((props.values?.invCheckoutIsAltQty === 'altqtyyes' ? props.values?.offerQty : checkoutPageData?.qty) * offerAmountValue)?.toFixed(2)) : ''}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </p>
                                <p style={{marginTop: '-6px'}}>
                                    <small class="text-muted">
                                        <em>*does not include tax or any other applicable charges.</em>
                                    </small>
                                </p>
                                {promoCodeSection(props.values)}
                                {btnsAttach()}
                            </div>
                        </div>
                    </OrderDetail>
                </ReviewOrder>
            </div>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=''
                content={modalContent}
                link={modalLink}
                alertType={alertType}
                callBackAlert={() => {
                    // history.goBack();
                    if (alertType === 'buyerInvCheckoutAccept' || alertType === 'redirectCheckoutToMyOffers') {
                        let obj = {
                            postType: "PostInventory",
                            type: "bidsPalletOffers",
                            activePage: 'PostInventory',
                            // activeSearch:'Dashboard',
                            expanded: 'panel1'
                        }
                        dispatch({ type: 'BIDS_INVENTORY', payload: obj })
                        history.push({ pathname: '/view-my-offers-on-pallet-inventory' })
                    }
                }}
            />
        </>
    );
};

export default BuyerInventory;

const DeliveryWindowSection = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-gap: 0 30px;
    .file-input-wrapper .MuiFormControl-root{
        height: 37px;
    }
    .app-input-text{
        margin-bottom: 0px !important;
    }
    @media (max-width:500px) {
      grid-template-columns: 1fr;
    }
`;
const Description = styled.div`
  position: relative;
  padding-left: 62px;

  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec{
    margin-top: 10px;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    }
  }
`;
